import { NodeRendererProps } from "@sanity/block-content-to-react";
import React from "react";
import { ElementClasses } from "./PortableText";

interface Props {
  sanityProps: React.PropsWithChildren<NodeRendererProps>;
  customElementClasses?: ElementClasses;
}

const BlockRenderer = ({ sanityProps, customElementClasses }: Props) => {
  let HtmlElement = sanityProps?.node?.style as keyof JSX.IntrinsicElements;

  if (
    !HtmlElement?.length ||
    (HtmlElement?.length && (HtmlElement as string) === "normal")
  ) {
    HtmlElement = "p";
  }

  let customElementClass = customElementClasses?.[HtmlElement];

  switch (HtmlElement as string) {
    case "h3Subheader":
      HtmlElement = "h3";
      break;
  }

  if (!customElementClass?.length) {
    customElementClass = customElementClasses?.default;
  }

  if (!customElementClass?.length) {
    customElementClass = "text-current";
  }

  return <HtmlElement className={customElementClass}>{sanityProps.children}</HtmlElement>;
};

export default BlockRenderer;
